/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/fp/placeholder.js
// module id = 45
// module chunks = 1